import apiSlice from "../api/apiSlice";

export const lossesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* POST */
    addNewLosses: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        return {
          url: `/erse/losses`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "ERSE", id: "LIST" }],
    }),
    /* GET */
    getLossesYears: builder.query({
      query: () => ({
        url: `/erse/losses/years`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "ERSE", id: "LIST" }],
    }),
    getLossesByYearPagination: builder.query({
      query: ({ year, page, limit, date, time, voltageLevel, sortColumn, sortDirection }) => ({
        url:
          `/erse/losses/${year}/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${voltageLevel ? `&voltage_level=${voltageLevel}` : ""}` +
          `${sortDirection ? `&sortDirection=${sortDirection}` : ""}` +
          `${sortColumn ? `&sortColumn=${sortColumn}` : ""}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
    }),
    /* DELETE */
    deleteLossesByYear: builder.mutation({
      query: (value) => ({
        url: `/erse/losses/${value}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "ERSE", id: "LIST" }],
    }),
  }),
});

export const {
  useGetLossesYearsQuery,
  useGetLossesByYearPaginationQuery,
  useAddNewLossesMutation,
  useDeleteLossesByYearMutation,
} = lossesApiSlice;
